/** GenericRegistry
 * Copyright (c) 2023 Beau Ner Chesluk / Whatever FZCO
 *
 * Provided under license to iWarranty Limited
 *
 * iWarranty may freely use this code for any purpose, commercial or otherwise,
 * but will not retain any rights to control or restrict its usage in any other software development.
 *
 * It is my eventual intention to release this code under a permissive open-source license
 */

// import { MakeBootThrower } from '@zerolabs/bootthrower';

export class GenericRegistry<TYPE> {
  Items: { [key: string]: TYPE } = {};
  Name: string;
  // BootThrower?: ReturnType<typeof MakeBootThrower>;

  constructor(name: string, BootTimer = -1) {
    this.Name = name;
    // if (BootTimer > -1) {
    //   this.BootThrower = MakeBootThrower(BootTimer);
    // }
  }

  Get(key: string): TYPE {
    if (!this.Items[key]) {
      throw new Error(`Registry ${this.Name} - not holding any "${key}"`);
    }
    return this.Items[key];
  }

  Register(item: TYPE, key: string) {
    if (this.Items[key]) {
      const errorMsg = `Registry ${this.Name} - already registered an item - "${key}"`;
      // if (this.BootThrower) {
      //   this.BootThrower.ThrowErrorIfWeAreBootingNow(errorMsg);
      // } else {
      throw new Error(errorMsg);
      // }
    }
    this.Items[key] = item;
  }

  forEach(callback: (item: TYPE, key: string) => void) {
    for (const key in this.Items) {
      callback(this.Items[key], key);
    }
  }
}

export default GenericRegistry;
